import React, { Component } from 'react';
import './shareErrorMask.scss';
import { store } from 'Store/store.index';
import { inject, observer } from 'mobx-react';
import second from './Shared/images/error-link.png';
@inject('appStore', 'userStore', 'accountStore', 'historyStore', 'homePageStore')
@observer
class shareErrorMask extends Component {
  backToHome = () => {
    window.history.pushState('', '', '/');
    store.appStore.setHomeHeader();
    store.appStore.updateShowShareErrorMask(false);
    store.appStore.updateShowHomeStart(true);
  };
  async componentDidMount() {
    document.body.style.overflow = 'hidden';
  }
  render() {
    return (
      <div className="shareErrorMask">
        <img src={second} alt="" />
        <h2>链接已失效</h2>
        <p>
          该链接不存在或已失效 <a onClick={this.backToHome}>去首页&gt;</a>
        </p>
      </div>
    );
  }
}
export default shareErrorMask;
